import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { CloudUpload } from '@material-ui/icons';

import pdf from '../assets/img/pdf.png';

const styles = {
  dropzone: {
    padding: '20px 10px',
    marginBottom: '20px',
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: '125px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
  },
  cloudUpload: {
    fontSize: '40px',
  },
  pdf: {
    padding: '10px',
    height: '30px',
  },
};

class CustomDropzone extends PureComponent {
  constructor() {
    super();

    this.state = {
      files: [],
    };

    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    this.props.onDrop(files);
    this.setState({ files });
  }

  renderUploadMessage() {
    const { classes } = this.props;

    return (
      <Grid container direction="column" alignItems="center" justify="center">
        <Grid item>
          <p>
            Arrastre el archivo aquí, o haga clic para
            seleccionar el archivo que desea cargar.
          </p>
        </Grid>
        <Grid item>
          <CloudUpload className={classes.cloudUpload} />
        </Grid>
      </Grid>
    );
  }

  renderFile() {
    const { classes } = this.props;
    const { files } = this.state;

    return (
      <Grid container alignItems="center" justify="center">
        <Grid item>
          <img className={classes.pdf} src={pdf} alt="pdf" />
        </Grid>
        <Grid item>
          <p>{files[0] && files[0].name}</p>
        </Grid>
      </Grid>
    );
  }

  render() {
    return (
      <div className="dropzone">
        <Dropzone
          style={styles.dropzone}
          onDrop={this.onDrop}
          accept="application/pdf"
          multiple={false}
        >
          {({ acceptedFiles }) => {
            if (acceptedFiles.length) return this.renderFile();
            return this.renderUploadMessage();
          }}
        </Dropzone>
      </div>
    );
  }
}

export default withStyles(styles)(CustomDropzone);

CustomDropzone.propTypes = {
  classes: PropTypes.object.isRequired,
  onDrop: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dropzone.js